export const ADD_SENDER: string = "ADD_SENDER";
export const CLEAR_SENDERS: string = "CLEAR_SENDERS";

export function addSender(sender: string): IAddSenderActionType {
    return { type: ADD_SENDER, sender:sender};
}
export function clearSenders(): IClearSenderActionType {
    return { type: CLEAR_SENDERS};
}


interface IAddSenderActionType { type:string,sender: string }
interface IClearSenderActionType { type:string }